
export var emptystate = {
  "style_emptystate_default": {
    "button": "style_button_medium_orange_bg"
  }
};

export var toast = {
  "style_toast_failed": {
    "status": "error"
  },
  "style_toast_success": {
    "status": "success"
  },
  "style_toast_text": {
    "status": "info"
  }
};
